import { Permission } from "@forgepoint/shared";
import Layout from "@/components/layout";
import AccessRestricted from "@/components/AccessRestricted";
import OpportunitiesController from "@/modules/opportunities/OpportunitiesController";
import { useHasAnyPermission } from "@/store/authStore";

export default function Opportunities() {
  const breadcrumbs = [{ label: "Opportunities", current: true }];
  const canView = useHasAnyPermission(
    Permission.OPPORTUNITIES_VIEW_OWN,
    Permission.OPPORTUNITIES_VIEW_ALL,
  );

  if (!canView) {
    return (
      <AccessRestricted
        breadcrumbs={breadcrumbs}
        message="You do not have access to opportunities."
      />
    );
  }

  return (
    <Layout
      breadcrumbs={breadcrumbs}
      className="flex flex-col overflow-y-hidden"
    >
      <OpportunitiesController />
    </Layout>
  );
}
